var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "deactiveModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content" },
          [
            _vm._m(0),
            _c("div", { staticClass: "modal-body desc-text" }, [
              _c(
                "div",
                { staticClass: "modal-title" },
                [
                  _c("div", { staticClass: "title-text" }, [
                    _vm._v("Are you sure you want to deactivate the User(s)?"),
                  ]),
                  _vm._l(_vm.users, function (user, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "bold-text ft-18 break-word" },
                      [
                        _c("span", [
                          _vm._v(_vm._s(user.user_name_and_email.email)),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c("p", { staticClass: "pt-20" }, [
                _vm._v(
                  "By deactivating this user(s), the user(s) will not able to access the portal for the below account."
                ),
              ]),
              _c("p", { staticClass: "bold-text" }, [
                _vm._v(_vm._s(_vm.account.account_name)),
              ]),
            ]),
            _c("div", { staticClass: "modal-footer deactiveModal-bgcolor" }, [
              _c("div", { staticClass: "col-sm-6 col-xs-12 mr-tp-10" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    attrs: { href: "#ConfirmationModal" },
                    on: { click: _vm.deactivateUser },
                  },
                  [_vm._v("Yes, please deactivate")]
                ),
              ]),
              _vm._m(1),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header deactiveModal-bgcolor" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#deactiveModal",
          },
        },
        [_vm._v("×")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6 col-xs-12 mr-tp-10" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-blue-button",
          attrs: { "data-toggle": "modal", "data-target": "#deactiveModal" },
        },
        [_vm._v("No, keep User active")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }